/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FeatureContext } from '../contexts';

interface IFeatureType {
  isCSCEnabled: boolean;
  isCNEdEnabled: boolean;
  isNLRValidationEnabled: boolean;
  isAIDETValidationEnabled: boolean;
  isBSSRValidationEnabled: boolean;
}

/**
 * Redux slice for managing feature flag state using Redux Toolkit's `createSlice`.
 *
 * This slice handles actions related to enabling or disabling application features, such as:
 * - Setting feature flags for CSC, CNEd, and Validation modules
 *
 * @property {object} initialState - The initial state for the feature context.
 * @property {Function} setFeatures - Updates the feature flags in the state.
 *
 * @example
 * dispatch(setFeatures({ isCSCEnabled: true, isCNEdEnabled: false, isNLRValidationEnabled: true, isAIDETValidationEnabled: false }));
 *
 * @returns {object} The feature slice reducer and actions.
 */
const featureSlice = createSlice({
  name: 'feature',
  initialState: FeatureContext,
  reducers: {
    setFeatures: (state, action: PayloadAction<IFeatureType>) => {
      return {
        ...state,
        ...action.payload
      };
    }
  }
});

export const { setFeatures } = featureSlice.actions;

export default featureSlice.reducer;
